export const sugaredFlatbread = {
  id: "sugaredFlatbread",
  link: "/#/recipes/recipes/sugaredFlatbread",
  name: "Sugared Flatbread",
  cuisine: "Alethi",
  summary: "Deep-fried rice flour flatbread, covered in cinnamon sugar",
  inspiration: "buñuelos",
  quantity: "6",
  time: "45 minutes",
  notes:
    'There were a few ways to interpret "flatbread crusted with sugar." I chose to go with rice flour rather than corn because I think the flavor lends itself better to desserts. As for the cooking method, who doesn\'t like deep fried dough covered in sugar?',
  quotes:
    "Tables lined the walkway here, piled with food. Candied meats, stacks of flatbread crusted with sugar, fruits and pastries. (Oathbringer ch 78)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/sugared-flatbread-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "water",
          display: "1 cup water"
        },
        {
          item: "salt",
          display: "1/4 tsp salt"
        },
        {
          item: "rice",
          display: "1 cup rice flour"
        },
        {
          item: "sugar",
          display: "1/4 cup granulated sugar"
        },
        {
          item: "cinnamon",
          display: "1/2 tbsp ground cinnamon"
        },
        {
          item: "vegetableOil",
          display: "Vegetable oil for frying"
        }
      ]
    }
  ],
  steps: [
    "Bring water and salt to a boil in a saucepan. Add rice flour all at once and mix until combined.",
    "Remove from heat, cover, and let rest 10 minutes. In the meantime, mix the sugar and cinnamon in a small bowl.",
    "Knead the cooled dough into a ball. Separate into 6 balls. Heat a deep frier to 350 degrees Fahrenheit.",
    "One ball at a time, roll the ball between two sheets of parchment paper until very thin, about 6 inches in diameter. Peel off the paper and place in the deep frier.",
    "Fry 1 minute on the first side until bubbly. Then flip and fry 2-3 minutes more until crispy. It's done when the middle is crisp and doesn't feel soft when you poke it with a fork.",
    "Drain on paper towels for 30 seconds, then sprinkle both sides with a small spoonful of cinnamon sugar."
  ]
}
